import Segment from '../shared/segment';
import {LessonType} from '../../api/student-question';

export type LessonTitlePropsType = {
  lesson: LessonType;
};

function LessonTitle({ lesson }: LessonTitlePropsType) {
  return (
    <Segment textAlign='center' className='text-lg font-medium'>
      <p>سوالات درس {lesson.name}</p>
    </Segment>
  );
}

export default LessonTitle;
